<template>
  <div class="big toDo-item">
    <div class="page_title">待办事项</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <el-tabs v-model="activeName">
          <el-tab-pane label="待处理" name="1"> </el-tab-pane>
          <el-tab-pane label="已处理" name="2"> </el-tab-pane>
        </el-tabs>
        <component :is="currentComponent" />
      </div>
    </div>
  </div>
</template>
  
  <script>
import _ from "lodash";
import ToBeProcessed from "./toBeProcessed.vue";
import Processed from "./processed.vue";
export default {
  components: {
    ToBeProcessed,
    Processed,
  },
  data() {
    return {
      activeName: "1",
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    currentComponent() {
      switch (this.activeName) {
        case "1":
          return ToBeProcessed;
        case "2":
          return Processed;
        default:
          return ToBeProcessed;
      }
    },
  },
  methods: {},
};
</script>
  
  <style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
</style>
  